import './PasswordRest.css'
import { TiCancel } from 'react-icons/ti';
import { Link, useNavigate, useParams } from 'react-router-dom';
import useForm from './useForm';
import { loginForm } from './utility/formConfig';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { axiosInstance } from '../../../config.util';

export default function Login(){
    const { renderFormInputs, isFormValid } = useForm(loginForm);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [serverMsg, setServerMsg] = useState({
        emilErrorMsg: '' ,
        passMissMatchMsg: '' ,
        successSignin: '',
        unIdentifiedErr: ''
    })
    const navigate = useNavigate();
    const param = useParams();
    const url = `/password/password-reset/${param.id}/${param.otp}`

    useEffect(()=>{
        let arrOfInp = [...document.getElementsByClassName('pswdreset-input')]
        // console.log('from input',arrOfInp);
        for (let i = 0; i < arrOfInp.length; i++) {
            // console.log('from input',arrOfInp[i].computedName);
            // console.log(arrOfInp[i].value);
            if(arrOfInp[i].computedName === 'email'){
                // console.log('got the value', arrOfInp[i].value);
                // console.log('got computedValue', arrOfInp[i].computedName);
                setEmail(arrOfInp[i].value)
            }
            else if(arrOfInp[i].computedName === 'password'){
                // console.log('got the value', arrOfInp[i].value);
                // console.log('got computedValue', arrOfInp[i].computedName);
                setPassword(arrOfInp[i].value)
            }
        }
    // }, [confirmPassword, password])
    })

    const formSubmit = (e)=>{
        e.preventDefault()
        const user = {
            email: email,
            password: password
        }
        pswdResetApiCall(user)
    }

    const pswdResetApiCall = async (user)=>{
        try {
            await axiosInstance.post(url, user, {
                headers: {'Content-Type': 'application/json'},
            }).then((res=>{
                console.log('response from backend:',res.data);
                setServerMsg({
                    successSignin: 'Welcome, success signin'
                })
                localStorage.setItem('usrdev', JSON.stringify(res.data));
                // console.log('SUCCESS...');
                navigate('/')
            })).catch(error=>{
                if(error.response.data.hasOwnProperty('notVerified')){
                    setServerMsg({
                        unIdentifiedErr: 'You not verified yet :) check your mail'
                    })
                }else{
                    setServerMsg({
                        unIdentifiedErr: 'Invalid Crediential'
                    })
                }
            });
        } catch (error) {
            setServerMsg({
                unIdentifiedErr: 'Something Went Wrong try again working realy hard'
            })
        }
    }
    
    return(
        <div className="pswdreset__container">
            <div className="pswdreset__wrapper">
                <div className="pswdreset__details-left">
                    <div className="pswdreset_box">
                        <div className="lb-nested">
                            <div className="pswdreset-desc">
                                <span className='whatisIt'>Productivity <br />Network</span>
                                <hr className='spacer'/>
                                <span className='wr'>We are</span>
                                <h2 className='appname'>next gen DEVHUB</h2>
                                <p className='app-desc'>Oath to build a better <span>developer</span> community.</p>
                                <p className='app-desc-para'>We invite all dev student & tech lover</p>
                                <h4>Lets build, create & learn, good Change</h4>
                            </div>
                            <div className="pswdreset-linkto">
                                <span>Back to login</span>
                                <Link to="/login">
                                    <span className='linkto-pswdreset'>Login</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pswdreset__details-right">
                    {serverMsg.unIdentifiedErr ? <span className='si__server__message'> {serverMsg.unIdentifiedErr} </span>:null} 
                    {serverMsg.emilErrorMsg ? <span className='si__server__message'> {serverMsg.emilErrorMsg} </span>:null}
                    {serverMsg.successpswdreset ? <span className='si__server__message--success'> {serverMsg.successpswdreset} </span>:null}
                    <div className='pswdreset__heading'>Reset Password,</div>
                    <form className="pswdreset__main" onSubmit={formSubmit}>
                        {renderFormInputs()}
                        <button className={`btn pswdreset__btn-main ${!isFormValid()?'ds_btn':"alw_btn"}`} type='submit' disabled={!isFormValid()}>{!isFormValid() ? <TiCancel />:'Login'}</button>
                    </form>
                </div>
            </div>
        </div>
    )
}